import { type HTMLAttributes, useMemo, useState } from "react";
import styled from "styled-components";
import FaqModal from "./FaqModal";
import { HeaderVariant, Header } from "./Header";
import {
  combineMenuItems,
  createFaqHeaderProps,
  useAuthHeaderElements,
} from "./HeaderObjects";
import {
  useThemeColorFromHeaderBackground,
  type HeaderBackground,
} from "./HeaderBackground";
import type { AccidentReportViewModel } from "#accident-statement/schema";

const StaticHeaderWrapper = styled.div
  .attrs<HeaderBackgroundProps>({})
  .withConfig({
    shouldForwardProp(prop) {
      return prop !== "background";
    },
  })`
  background-color: ${({ theme, background }) =>
    background === "green"
      ? (theme.nafColor.primary?.dew ?? "#e9f3e6")
      : (theme.nafColor.signature?.white ?? "#ffffff")};
  width: 100%;
  z-index: 2;
`;

type HeaderBackgroundProps = {
  background?: HeaderBackground;
};

export interface StaticHeaderProps
  extends HTMLAttributes<HTMLDivElement>,
    HeaderBackgroundProps {
  report?: AccidentReportViewModel;
}

export default function StaticHeader({ report, ...props }: StaticHeaderProps) {
  const authHeaderProps = useAuthHeaderElements();
  const [showFaq, setShowFaq] = useState(false);
  const faqProps = createFaqHeaderProps(showFaq, setShowFaq);

  const elements = useMemo(
    () => combineMenuItems([...authHeaderProps, faqProps]),
    [authHeaderProps, faqProps],
  );

  const { background } = props;

  useThemeColorFromHeaderBackground(background);

  return (
    <StaticHeaderWrapper {...props}>
      <FaqModal isOpen={showFaq} onClose={() => setShowFaq(false)} />
      <Header variant={HeaderVariant.Static} elements={elements} />
    </StaticHeaderWrapper>
  );
}
